export function isEmptySchedule(record) {
    return record?.parentDisplayStatus === "EMPTY";
}

export function isFullyAgreed(record) {
    const total = Number(record?.allocationCount || 0);
    const agreed = Number(record?.agreedAllocationCount || 0);
    return total > 0 && total === agreed;
}

export function isPartiallyAgreed(record) {
    const total = Number(record?.allocationCount || 0);
    const agreed = Number(record?.agreedAllocationCount || 0);
    return total > 0 && agreed > 0 && agreed < total;
}

export function isBulkManageEligible(record) {
    return Number(record?.allocationCount || 0) === 0;
}

export function isBulkAgreeEligible(record) {
    return (
        record?.parentDisplayStatus === "SINGLE" &&
        Number(record?.allocationCount || 0) === 1 &&
        Number(record?.agreedAllocationCount || 0) === 0
    );
}

export function canDeleteScheduleRow(record, canDelete) {
    if (!canDelete) return false;
    return Number(record?.agreedAllocationCount || 0) === 0;
}